import React from 'react'
import { Grid } from 'antd'

const { useBreakpoint } = Grid;

const useResponsive = () => {
  const screens = useBreakpoint();
  return React.useMemo(() => {
    const isMobile = screens.xs;
    const isTablet = !screens.lg;
    const isDesktop = screens.lg;

    return {
      isMobile,
      isTablet,
      isDesktop
    }
  }, [screens])
}

export default useResponsive;